import Utils from '../MiscUtils'
const { detect } = require('detect-browser')
const browser = detect()
const browserName = browser ? browser.name : 'undetected'

const AnalyticsReducer = (
  state = {
    platform: `Dashboard - ${browserName}`,
    versionCode: Utils.VERSION_CODE
  },
  action
) => {
  switch (action.type) {
    case 'ANALYTICS_UPDATE_INFO':
      return Object.assign({}, state, action.info);
    default:
      return state
  }
}

export default AnalyticsReducer



// WEBPACK FOOTER //
// ./src/infra/reducers/AnalyticsReducer.js